import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=502ffd65&scoped=true"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ffd65",
  null
  
)

export default component.exports